export type AvailableLanguages = 'pl' | 'en' | 'uk' | 'ru';
export const SUPPORTED_LANGS = ['pl', 'en', 'uk', 'ru'];
export const langKeyToLocale: Record<AvailableLanguages, string> = {
  pl: 'pl',
  en: 'en-GB',
  uk: 'uk',
  ru: 'ru',
};

export const getLocaleForLang = (lang: string | null | undefined): string => {
  return langKeyToLocale[lang as AvailableLanguages] || langKeyToLocale.en;
};

// Anchor text used when rendering the raw online-meeting link as a clickable element.
// Kept as a constant map (single source of truth) so consultant-facing previews can show
// the text in the foreigner's language regardless of the consultant's current UI language.
export const ONLINE_MEETING_LINK_TEXT: Record<AvailableLanguages, string> = {
  pl: 'Rozpocznij spotkanie',
  en: 'Start the meeting',
  ru: 'Начать встречу',
  uk: 'Почати зустріч',
};

export const getOnlineMeetingLinkText = (lang: string | null | undefined): string =>
  ONLINE_MEETING_LINK_TEXT[lang as AvailableLanguages] || ONLINE_MEETING_LINK_TEXT.en;

export const defaultLanguages = [
  { id: 'ecd424ee-9222-49fd-a43f-04123a4800c7', name: 'Polski', key: 'pl', flagFile: null as any },
  { id: 'e563d944-5f07-462c-83b3-b16e8fb2dc53', name: 'English', key: 'en', flagFile: null },
  { id: '238bdbaf-77a0-4261-93df-b4182d3e2cd7', name: 'Русский', key: 'ru', flagFile: null },
  { id: '3d7eb76d-e22e-4b21-878b-87b5288434e1', name: 'українська', key: 'uk', flagFile: null },
];
